export default {
  ru: {
    title: "РЕМОНТ АСИНХРОННЫХ ЭЛЕТКРОДВИГАТЕЛЕЙ",
    content: "<p class='py-2'>Мы осуществляем ремонт асинхронных электрических двигателей любой сложности, а именно:</p>\n" +
      "\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Ремонт высоковольтных асинхронных электродвигателей с изоляцией «Монолит»;</li>\n" +
      "<li class='list-disc'>Ремонт высоковольтных асинхронных безклиновых электродвигателей;</li>\n" +
      "<li class='list-disc'>Ремонт высоковольтных асинхронных электродвигателей взрывозащищенного исполнения;</li>\n" +
      "<li class='list-disc'>Ремонт асинхронных электродвигателей с фазным ротором;</li>" +
      "<li class='list-disc'>Ремонт асинхронных электродвигателей с короткозамкнутым ротором.</li>" +
      "</ul>\n"
  },
  en: {
    title: "REPAIR OF ASYNCHRONOUS ELECTRIC MOTORS",
    content: "<p class='py-2'>We carry out repair of asynchronous electric motors of any complexity, namely:</p>\n" +
      "\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Repair of high-voltage asynchronous electric motors with insulation \"Monolith\";</li>\n" +
      "<li class='list-disc'>Repair of high-voltage asynchronous wedge-free electric motors;\n</li>\n" +
      "<li class='list-disc'>Repair of high-voltage asynchronous explosion-proof electric motors;</li>\n" +
      "<li class='list-disc'>Repair of asynchronous motors with a phase rotor;</li>" +
      "<li class='list-disc'>Repair of asynchronous squirrel-cage electric motors.</li>" +
      "</ul>\n"
  },
  ua: {
    title: "РЕМОНТ АСИНХРОННИХ ЕЛЕКТРОДВИГУНІВ",
    content: "<p class='py-2'>Ми здійснюємо ремонт асинхронних електричних двигунів будь-якої складності, а саме:</p>\n" +
      "\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Ремонт високовольтних асинхронних електродвигунів з ізоляцією «Моноліт»;</li>\n" +
      "<li class='list-disc'>Ремонт високовольтних асинхронних безклінових електродвигунів;</li>\n" +
      "<li class='list-disc'>Ремонт високовольтних асинхронних електродвигунів вибухонебезпечного виконання;</li>\n" +
      "<li class='list-disc'>Ремонт асинхронних електродвигунів з фазним ротором;</li>" +
      "<li class='list-disc'>Ремонт асинхронних електродвигунів з короткозамкненим ротором.</li>" +
      "</ul>\n"
  },
}

